import * as firebase from 'firebase/app';
import {GroupPath} from "./GroupPath";
import {t3, t4} from "../components/DrawingDataType";

export class SmileRegister {

    private documentReference?: firebase.firestore.DocumentReference<firebase.firestore.DocumentData>;

    constructor(
        private firestoreInstance: firebase.firestore.Firestore,
        private groupPath: GroupPath,
        private data: t4
    ) {

    }

    async add() {
        console.log('[ SmileRegister.add : start ]');
        try {
            this.documentReference = await this.firestoreInstance.collection(this.groupPath.value).add(this.data);
        } catch (error) {
            console.error('Error writing new message to database', error);
        }
        console.log('[ SmileRegister.add : end ]');
    }

    async addPath(value: t3) {
        console.log('[ SmileRegister.addPath : start ]');
        if (!this.documentReference) throw new Error();
        await this.documentReference.update(
            'paths',
            firebase.firestore.FieldValue.arrayUnion(value)
        );
        console.log('[ SmileRegister.addPath : end ]');
    }

    async updateDone() {
        console.log('[ SmileRegister.updateDone : start ]');
        if (!this.documentReference) throw new Error();
        await this.documentReference.update(
            'isDone', true
        );
        console.log('[ SmileRegister.updateDone : end ]');
    }

    setCountry(value: string) {
        this.data.country = value;
    }

    setPrefecture(value: string) {
        this.data.prefecture = value;
    }
}